<div class="dialog task-details-wrapper">
  <!--  Top Header -->
  <div class="top-header">
    <!-- Header For Mobile  -->
    @if (isMobileView) {
      <div class="mobile-app-bar right-action-icons-only sticky-header">
        @if (!alertType && !currentTask.denyById) {
          @if ((_permissionService.isAdmin() || currentTask.organizerId === GetUserId()) && currentTask?.approvedStatus === ApprovedStatus.Approved) {
            <div (click)="openTaskBottomSheet(currentTask)" class="mobile-app-bar__action-icon">
              <app-icon iconName="pencil" size="16px"></app-icon>
            </div>
          }
        }

        @if (_permissionService.isAdmin() || currentTask.organizerId === GetUserId()) {
          <div (click)="deleteTask(currentTask)" class="mobile-app-bar__action-icon">
            <app-icon iconName="trash" size="16px"></app-icon>
          </div>
        }
        <div (click)="close()" class="mobile-app-bar__action-icon">
          <app-icon iconName="close" size="16px"></app-icon>
        </div>
      </div>
    }

    <!-- Header For Web  -->
    @if (!isMobileView) {
      <header class="dialog__header">
        <h3 class="dialog__header__title"></h3>
        <div class="dialog__header__action-buttons">
          @if (isUserAuthor || isUserAdmin) {
            @if (!alertType) {
              <div class="dialog__header__action-buttons__button">
                <span>
                  <app-icon (click)="openTaskBottomSheet(currentTask)" [cssStyle]="{ margin: '4px' }" iconName="pencil" size="20px"></app-icon>
                </span>
              </div>
            }
            <div class="dialog__header__action-buttons__button">
              <span>
                <app-icon (click)="deleteTask(currentTask)" [cssStyle]="{ margin: '4px' }" iconName="trash-bin" size="20px"></app-icon>
              </span>
            </div>
          }
          <div class="dialog__header__action-buttons__button">
            <span>
              <app-icon (click)="close()" [cssStyle]="{ margin: '4px' }" iconName="close" size="20px"></app-icon>
            </span>
          </div>
        </div>
      </header>
    }
  </div>

  <!-- Main Area -->
  <div class="dialog__content">
    @if (!isLoading && currentTask) {
      @if (alertType) {
        <div [class]="{ 'px-16': isMobileView }">
          <app-alert-message [alertType]="alertType" [denyReason]="currentTask?.denyReason" [showCloseIcon]="false" size="small"></app-alert-message>
        </div>
      }
      @if (showUpdatedRecord && isUserAdmin) {
        <app-tabs-selection (selectedTab)="onUpdateRecordTabSelection($event)" [tabs]="updateSelectionTabs" [selectedTabName]="currentUpdatedRecordTab" marginBottom="30px"></app-tabs-selection>
      }

      <div class="main-content-area">
        <div class="main-image-wrapper background-loading mt-10">
          <img [src]="currentTask?.imageUrl" alt="" appDefaultImage="assets/images/defaults/task.png" loading="lazy" />
        </div>
        <div class="flex-row-start-center mt-36">
          @if (!isMobileView) {
            <input
              (change)="markTaskAsComplete($event)"
              [checked]="currentTask.status === SubtaskStatus.Complete"
              [disabled]="currentTask.status === SubtaskStatus.Complete"
              class="checkbox green-checkbox"
              type="checkbox"
            />
          }
          <h2 class="main-content-area__heading ml-13" [class.ml-13]="!isMobileView">{{ currentTask?.title }}</h2>
        </div>

        <p [innerHTML]="currentTask?.description" class="main-content-area__text mt-30"></p>
        <div class="row mt-33 g-3">
          <!-- Task Status -->

          @if (currentTaskStatus) {
            <div class="col-5">
              <div class="d-flex justify-content-start align-items-center">
                <app-icon iconName="check-circle"></app-icon>
                <p class="ml-10 main-content-area__label" translate>Status</p>
              </div>
            </div>
            <div class="col-7">
              @if (currentTaskStatus === TaskStatus.ToDo) {
                <app-badge [borderRadius]="'6px'" [cssStyle]="{ padding: '4px 10px' }" [text]="currentTaskStatus | translate" backgroundColor="var(--orange-opaque)"></app-badge>
              }
              @if (currentTaskStatus === TaskStatus.InProgress) {
                <app-badge
                  [borderRadius]="'6px'"
                  [cssStyle]="{ padding: '4px 10px', color: 'var(--deep-yellow)' }"
                  [text]="currentTaskStatus | translate"
                  backgroundColor="var(--yellow-opaque)"
                ></app-badge>
              }
              @if (currentTaskStatus === TaskStatus.Completed) {
                <app-badge
                  [borderRadius]="'6px'"
                  [cssStyle]="{ padding: '4px 10px', color: 'var(--dark-teal)' }"
                  [text]="currentTaskStatus | translate"
                  backgroundColor="var(--teal-opaque)"
                ></app-badge>
              }
            </div>
          }

          <!-- Task Responsible -->

          <div class="col-5">
            <div class="d-flex justify-content-start align-items-center">
              <app-icon iconName="user"></app-icon>
              <p class="ml-10 main-content-area__label" translate>Responsible</p>
            </div>
          </div>
          <div class="col-7">
            <div class="d-flex justify-content-start align-items-center">
              <div class="user-image-wrapper background-loading-tiny">
                <img [appFetchProfileImage]="currentTask?.user?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
              </div>
              <p class="ml-10 main-content-area__label input-value">{{ currentTask?.user?.firstName }}</p>
            </div>
          </div>

          <!-- Task Group -->

          @if (currentTask?.groupId && currentTask?.group) {
            <div class="col-5">
              <div class="d-flex justify-content-start align-items-center">
                <app-icon iconName="user-pair"></app-icon>
                <p class="ml-10 main-content-area__label" translate>Group</p>
              </div>
            </div>
            <div class="col-7">
              <app-badge class="cursor-pointer" (click)="navigateToGroupDetails(currentTask?.group?.id)" [borderRadius]="'6px'" [text]="currentTask?.group?.name"></app-badge>
            </div>
          }

          <!-- Task Date -->

          <div class="col-5">
            <div class="d-flex justify-content-start align-items-center">
              <app-icon iconName="calendar"></app-icon>
              <p class="ml-10 main-content-area__label" translate>dates&filters.date</p>
            </div>
          </div>
          <div class="col-7">
            <p class="main-content-area__label input-value">{{ currentTask?.date | friendlyDate: false : true }}</p>
          </div>

          <!-- Task Tags -->

          @if (currentTask?.tags && currentTask?.tags.length) {
            <div class="col-5">
              <div class="d-flex justify-content-start align-items-center">
                <app-icon iconName="hash"></app-icon>
                <p class="ml-10 main-content-area__label" translate>Tags</p>
              </div>
            </div>
            <div class="col-7">
              <div class="flex-row-start-center gap-6 flex-wrap">
                @for (tag of currentTask.tags; track tag) {
                  <p class="main-content-area__label input-value tag tag-display mr-1">{{ tag | humanize | truncateText: 30 }}</p>
                }
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="loading"></ng-container>
    }

    <div class="mt-50 tabs-area">
      <app-dynamic-tabs>
        <ng-template [count]="currentTask?.subtasks?.length" [dynamicTabButtonCssStyle]="{ flexDirection: 'row' }" [tabName]="'Subtasks' | translate">
          @if (!isLoading) {
            <ul class="mt-36">
              @for (subTask of currentTask.subtasks; track subTask; let index = $index) {
                <li>
                  <div class="flex-row-between-center">
                    <div class="flex-row-start">
                      <input
                        (change)="markSubtaskAsComplete(subTask, $event)"
                        [checked]="+subTask?.status"
                        [disabled]="currentTask.status === SubtaskStatus.Complete || +subTask.status === SubtaskStatus.Complete"
                        class="checkbox green-checkbox"
                        id="{{ subTask?.id }}"
                        type="checkbox"
                      />
                      <label (click)="toggleSubTaskDetails(index)" class="tabs-area__text ml-9 cursor-pointer">
                        {{ subTask?.title }}
                      </label>
                    </div>
                    <div (click)="toggleSubTaskDetails(index)" class="cursor-pointer mobile-app-bar__action-icon">
                      <app-icon [iconName]="subTask.isArrowUp ? 'chevron-up' : 'chevron-down'" color="var(--slate-gray)" size="16px"></app-icon>
                    </div>
                  </div>
                  @if (expandedSubtaskIndex === index) {
                    <div class="card">
                      <p [innerHTML]="subTask?.description"></p>
                      <div class="flex-row-between-center mt-30">
                        <div>
                          <p class="sub-task-heading">{{ 'Task Assigned to' | translate }}:</p>
                          <div class="participants">
                            @if (subTask.assignedTo.length) {
                              <div class="participant-avatar">
                                @if (subTask.assignedTo.length > 3) {
                                  <a class="participant-count-badge">
                                    <span>+{{ subTask.assignedTo.length - 3 }}</span>
                                  </a>
                                }
                                @for (participant of subTask.assignedTo | slice: 0 : 3; track participant) {
                                  <a [tippy]="getParticipantName(participant.userId)" class="avatar-image background-loading-tiny">
                                    <img [appFetchProfileImage]="participant?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
                                  </a>
                                }
                              </div>
                            }
                            <p class="participant-count">{{ subTask.assignedTo.length }} {{ 'Participants' | translate }}</p>
                          </div>
                        </div>
                        <div>
                          <p class="sub-task-heading">{{ 'To be done by' | translate }}:</p>
                          <p class="content-text mt-10">{{ subTask?.date | date: 'dd.MM.yyyy' }}</p>
                        </div>
                      </div>
                    </div>
                  }
                </li>
              }
            </ul>
          } @else {
            <ngx-skeleton-loader [theme]="{ width: '100%', height: '200px' }"></ngx-skeleton-loader>
          }
        </ng-template>
        <ng-template [count]="taskParticipants.length" [dynamicTabButtonCssStyle]="{ flexDirection: 'row' }" [tabName]="'Participants' | translate">
          @if (!isLoading) {
            <div class="participants-grid mt-36">
              @for (participant of taskParticipants; track participant) {
                <div class="flex-row-start-center">
                  <div class="participants-image-wrapper background-loading-small">
                    <img [appFetchProfileImage]="participant?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
                  </div>
                  <h2>{{ participant?.fullName ?? participant?.firstName + ' ' + participant?.lastName | translate }}</h2>
                </div>
              }
            </div>
          } @else {
            <ngx-skeleton-loader [theme]="{ width: '100%', height: '200px' }"></ngx-skeleton-loader>
          }
        </ng-template>

        <!--   TODO: Below code is comments section, there is no backend ready for this section   -->

        <!--      <ng-template [count]="0" [tabName]="'Comments' | translate">-->
        <!--        <div class="comments">-->
        <!--          <div #chatPanel class="conversation-messages">-->
        <!--            <ng-container *ngFor="let message of messages; let i = index">-->
        <!--              <div class="message-wrapper">-->
        <!--                <div class="message-info">-->
        <!--                  <div class="flex-row-start g-3">-->
        <!--                    <div class="avatar-container">-->
        <!--                      <img alt="avatar" src="../../../../assets/images/placeholder.png" />-->
        <!--                    </div>-->
        <!--                    <div class="ml-16">-->
        <!--                      <h4 class="sender-name">-->
        <!--                        {{ message.user.username }}-->
        <!--                      </h4>-->
        <!--                      <div class="message-box last-message">-->
        <!--                        <p>{{ message.text }}</p>-->
        <!--                      </div>-->
        <!--                      <p class="message-time align-start">{{ message.sentAt | date: 'h:mm' }}</p>-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </ng-container>-->
        <!--          </div>-->

        <!--          <div class="conversation-input">-->
        <!--            <div class="attachment-option">-->
        <!--              <app-icon [cssStyle]="{ cursor: 'pointer', 'margin-top': '5px' }" [planeIcon]="true" iconName="paper-clip" size="24px"></app-icon>-->
        <!--            </div>-->
        <!--            <input (keyup.enter)="onSend()" [(ngModel)]="messageInput" [placeholder]="'messages.write a message' | translate" class="input" id="message" name="message" type="text" />-->
        <!--            <ng-container *ngIf="messageInput">-->
        <!--              <app-icon (click)="onSend()" [cssStyle]="{ cursor: 'pointer', 'margin-top': '5px' }" [planeIcon]="true" iconName="send" size="24px"></app-icon>-->
        <!--            </ng-container>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </ng-template>-->
      </app-dynamic-tabs>
    </div>
  </div>
  <!-- Admin Actions Footer -->
  @if (isUserAdmin && shouldShowAdminActions()) {
    <footer class="dialog__footer">
      <div class="dialog__footer__buttons">
        <app-button (clickEvent)="denyTask(currentTask, $event)" [idleText]="'Deny' | translate" cssClass="button-simple"></app-button>
        <app-button (clickEvent)="approveTask(currentTask, getApprovalType(), $event)" [idleText]="'Publish' | translate"></app-button>
      </div>
    </footer>
  }

  <!-- Mobile Complete Action Footer -->
  @if (isMobileView && shouldShowCompleteAction()) {
    <footer class="dialog__footer">
      <div class="dialog__footer__buttons">
        <app-button (clickEvent)="markTaskAsComplete()" [idleText]="'Mark As Complete' | translate"></app-button>
      </div>
    </footer>
  }
</div>

<ng-template #loading>
  <div [class.p-16]="isMobileView">
    <ngx-skeleton-loader [theme]="{ width: '98%', height: '210px', borderRadius: '10px' }" appearance="circle" count="1" />

    <ngx-skeleton-loader [theme]="{ width: '90%', height: '30px', borderRadius: '10px' }" appearance="circle" count="1" />

    <ngx-skeleton-loader [theme]="{ width: '98%', height: '100px', borderRadius: '10px' }" appearance="circle" count="1" />

    <ngx-skeleton-loader [theme]="{ width: '60%', height: '20px', borderRadius: '10px' }" appearance="circle" count="1" />

    <ngx-skeleton-loader [theme]="{ width: '60%', height: '20px', borderRadius: '10px' }" appearance="circle" count="1" />

    <ngx-skeleton-loader [theme]="{ width: '60%', height: '20px', borderRadius: '10px' }" appearance="circle" count="1" />
  </div>
</ng-template>
